<template>
    <div class="tabs_content">
        <section v-show="allowShowSelectOperator">
            <div class="left">
                <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
                <div class="field_left">
                    <select-box
                        id="operator"
                        v-model="entity.id_operator"
                        :options="operatorOptions"
                        :disabled="!!entity.id || !$_updateActionAllowed">
                        <translate class="translate">Operátor</translate>
                    </select-box>
                </div>
            </div>
        </section>
        <section>
            <div class="left">
              <detail-entity-info :entity="entity" v-if="entity.id">
              </detail-entity-info>
                <h2 v-else v-translate>Základní údaje</h2>
            </div>
            <div class="right">
                <div class="field_left">
                    <text-input id="deviceConfigName"
                            :required="true"
                            v-model="entity.name"
                            :disabled="!isEditable"
                            ref="nameref">

                        <translate class="translate">Název</translate>
                    </text-input>
                </div>
                <div class="field_right">
                    <select-box
                        id="id_device_type"
                        v-model="entity.id_device_type"
                        :options="deviceTypeOptions"
                        :disabled="!isEditable"
                    >
                        <translate class="translate">Typ zařízení</translate>
                    </select-box>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"
import DetailEntityInfo from "../../../common/DetailEntityInfo";

export default {
    name: "BasicSettings",
    components: {DetailEntityInfo, TextInput},
    mixins: [formFilterData, requiredFields],
    props: {
        entity: Object,
        isEditable: Boolean,
        deviceTypes: Array,
        operatorOptions: Array,
    },
    methods: {
      validateFormRequiredFields() {
          let nameError = null

          if (!this.entity.name) {
              nameError = this.$gettext('Zadejte název')
          }

          if (nameError !== null) {
              this.setFieldInvalid('nameref', true, nameError)
          } else {
              this.setFieldInvalid('nameref')
          }
      },
    },
    computed: {
        allowShowSelectOperator(){
          return this.isEditable ? this.$_createActionAllowedAllOrOwnAndGlobal : this.$_readActionAllowedAllOrOwnAndGlobal;
      },
        deviceTypeOptions() {
            let options = [{
                id: null,
                text: this.$gettext('Všechny typy zařízení')
            }];
            this._.forEach(this.deviceTypes, function (deviceType) {
                options.push({
                    id: deviceType.id,
                    text: deviceType.name
                })
            })
            return options
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/BasicSettings.vue